<template>
      <section class="league-name-sec m-bottom v-sheet" loading="lazy">
         <div class="favourate-game">
            <div class="fav-left">
               <a @click="$router.back()" title="Go Back" role="button" href="javascript:void(0)"> 
                  <span class="angle-left-box"><i class="fa-solid fa-angle-left"></i></span>
               </a>
               <span>Live Card</span>
            </div>
         </div>
      </section>

      <div class="v-card__text rummy-v-h">
         <div class="white--text about-tab-info">
            <h1>Rummy makes people richer. Play online and win real cash.</h1> 
            <p>{{$siteSettings?.data?.domain_name}} invites you to discover thrilling online poker tournaments and games. Here, you can play games like 3 patti online, Indian card games, poker, etc. online using secured deposits. Play and benefit from instant withdrawals and advanced software. Things like ‘play rummy win cash’ is an everyday situation for this platform where you can awaken the champion inside you. Also, those who enjoy online 3 patti real money can rejoice as we also offer a beginners guide on poker rules, 3 patti rules, etc. and hand rankings to make it simple to play poker online. Our endeavour in offering players a platform to win prizes is what drives our efforts. Learn all moves low to high using our comprehensive guide. To play and win, sign up to {{$siteSettings?.data?.domain_name}} now!</p>
         </div>
      </div>

      <section class="live-card space-l rummy-play-sec" loading="lazy">
         <div class="container">
            <!-- <div class="row no-gutters">
               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('oneday-teen-patti')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/teen-patti_one-day.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('t20-teen-patti')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/teen-patti_one-day.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('poker')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/poker-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('andhar-bahar')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/andar_bahar-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('7up7down')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/7up7down-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('32-cards')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/32-cards-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('dragon-tiger')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/dragon_tiger-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                  <a href="#" @click="gotoDetails('amar-akbar-antony')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/aaa-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>

               <div class="col-sm-2 col-4">
                  <div class="plat-game-2">
                     <a href="#" @click="gotoDetails('worli-matka')">
                        <figure class="sports-img-maker">
                           <img loading="lazy" src="@/assets/images/worli-matka-live-card.webp" alt="inplay">
                        </figure>
                     </a>
                  </div>
               </div>
            </div> -->
         </div>
      </section>
</template>

<script>
export default{
    name:'LiveCardInfo',
    data(){
      return{

      }
    },
    methods:{
      gotoDetails(type){
         this.$router.push('/markets/'+ type)
      }
    }
}
</script>